export default {
  title: 'Push-Benachrichtigungen',
  description: 'Senden Sie gezielte Push-Benachrichtigungen an Ihre Kunden',
  buttons: {
    new_campaign: 'Neue Kampagne',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Mobile App noch nicht live',
      description: 'Bitte warten Sie, bis die Mobile App live ist, bevor Sie Push-Benachrichtigungen senden können',
    },
  },
};
